import React, { HtmlHTMLAttributes } from "react";
import styles from "./SectionTitle.module.scss";
import { stringPresent } from "../utils/strings";
import clsx from "clsx";

export interface SectionTitleProps {
  variant: "wide" | "column";
  textColor?: "titanium" | "white";
  className?: string;
}

export interface SectionTitleHeadingProps {
  className?: string;
  tagline?: string;
  priority?: number;
}

export const SectionTitleBody: React.FC<
  React.PropsWithChildren<HtmlHTMLAttributes<HTMLDivElement>>
> = ({ className = undefined, children, ...props }) => {
  return (
    <div className={clsx(styles.body, className)} {...props}>
      {children}
    </div>
  );
};

export const SectionTitleHeading: React.FC<
  React.PropsWithChildren<SectionTitleHeadingProps>
> = ({ children, className, tagline, priority = 2 }) => {
  const TitleTag = `h${priority}` as keyof JSX.IntrinsicElements;
  const TaglineTag = `h${priority + 2}` as keyof JSX.IntrinsicElements;

  return (
    <div className={clsx(styles.heading, className)}>
      {stringPresent(tagline) && (
        <TaglineTag className={styles.tagline}>{tagline}</TaglineTag>
      )}
      <TitleTag>{children}</TitleTag>
    </div>
  );
};

export const SectionTitle: React.FC<
  React.PropsWithChildren<SectionTitleProps>
> = ({ variant, textColor, className, children }) => {
  return (
    <div
      className={clsx(styles.sectionTitle, className, {
        [styles.variantWide]: variant == "wide",
        [styles.variantColumn]: variant == "column",
        [styles.textColorTitanium]: textColor == "titanium",
        [styles.textColorWhite]: textColor == "white"
      })}
    >
      {children}
    </div>
  );
};
